import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
} from '@twistopayments/design-system/styles'

export const installStep = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    font-size: ${pxToRem(32)};
    font-weight: 500;
    line-height: 1.3;
    color: ${theme.palette.text.title};

    ${breakpoint.up('smMd')} {
      font-size: ${fontSize.xl};
      margin-bottom: 0;
    }
  }

  p {
    margin-top: ${size[8]};
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: ${theme.palette.tertiary.upperMediumContrast};

    ${breakpoint.up('smMd')} {
      font-size: ${fontSize.smMd};
    }
  }
`

export const icon = css`
  height: 42px;
  margin-bottom: ${size[24]};
`
